import { ACTIONS_KEY, CUSTOMERS_KEY } from '../CmdTable/constants';

export const EMPLOYEE_COST_CENTER = 'costCenter';
export const EMPLOYEE_CREATED_AT = 'createdAt';
export const EMPLOYEE_CREATED_BY = 'createdBy';
export const EMPLOYEE_CUSTOMER = 'customer';
export const EMPLOYEE_EMAIL = 'email';
export const EMPLOYEE_FIRST_NAME = 'firstName';
export const EMPLOYEE_IS_DRIVER = 'hasDriver';
export const EMPLOYEE_IS_USER = 'hasUser';
export const EMPLOYEE_ID = 'id';
export const EMPLOYEE_LAST_LOGGED_AT = 'lastLoggedAt';
export const EMPLOYEE_LAST_NAME = 'lastName';
export const EMPLOYEE_MODIFIED_AT = 'modifiedAt';
export const EMPLOYEE_MODIFIED_BY = 'modifiedBy';
export const EMPLOYEE_PERSONAL_NUMBER = 'personalNumber';
export const EMPLOYEE_ROLES = 'roles';
export const EMPLOYEE_STATUS = 'status';
export const EMPLOYEE_USERNAME = 'username';
export const EMPLOYEE_WORK_DEPT = 'workDepartment';

export const UUID_KEY = 'uuid';
export const ID_KEY = 'id';
export const EXTERNALID_KEY = 'externalId';
export const MANUFACTURER_KEY = 'manufacturer';
export const MODEL_KEY = 'model';
export const ASSIGNED_KEY = 'assigned';
export const STATE_KEY = 'state';
export const USAGE_START_KEY = 'usageStart';
export const USAGE_UNBLOCK_KEY = 'usageUnblock';
export const LAST_USAGE_KEY = 'lastUsage';
export const USAGE_END_KEY = 'usageEnd';
export const USAGE_START_ADDRESS_KEY = 'usageStartAddress';
export const USAGE_END_ADDRESS_KEY = 'usageEndAddress';
export const LAST_USAGE_ADDRESS_KEY = 'lastUsageAddress';
export const CUSTOMER_KEY = 'customer';
export const VEHICLE_LICENCE_NUMBER_KEY = 'vehicleLicenceNumber';
export const VEHICLE_KEY = 'vehicle';
export const USAGE_START_GPS_KEY = 'usageLatLonStart';
export const USAGE_END_GPS_KEY = 'usageLatLonEnd';
export const NAME_KEY = 'name';
export const MAC_ADDRESS_KEY = 'macAddress';
export const SERIAL_NUMBER_KEY = 'serialNumber';
export const USAGE_DURATION_KEY = 'duration';
export const TIME_KEY = 'time';
export const USAGE_START_COORDINATES_KEY = 'usageStartCoordinates';
export const USAGE_END_COORDINATES_KEY = 'usageEndCoordinates';

export const IS_OK = 'ok';
export const IS_INACTIVE = 'inactive';
export const IS_ACTIVE = 'active';
export const IS_PENDING = 'pending';
export const IS_BLOCKED = 'blocked';
export const IS_DELETED = 'deleted';
export const DEACTIVATE_USER = 'block-user';
export const RESET_USER = 'reset-password';
export const ACTIVATE_USER = 'send-an-email';
export const REACTIVATE_USER = 'unblock-user';

export const EMPLOYEE_TABLE_NAME = 'v1/person';
export const EMPLOYEE_TABLE_SETTINGS_KEY = 'person_v2';
export const TOTAL_KEY = 'total';
export const CHECKBOX_KEY = 'checkboxId';

export const EmployeesTableTranslationKeys = {
  costCenter: 'table_list.columns.costCenterId',
  customer: 'employee.field.customerId',
  email: 'table_list.columns.email',
  firstName: 'table_list.columns.drivers.name',
  hasDriver: 'table_list.columns.hasDriver',
  hasUser: 'table_list.columns.hasUser',
  lastLoggedAt: 'table_list.columns.lastLoggedAt',
  lastName: 'table_list.columns.lastName',
  personalNumber: 'table_list.columns.personalNumber',
  roles: 'table_list.columns.gdprUsers.role',
  status: 'table_list.columns.employees.status',
  username: 'table_list.columns.gdprUsers.username',
  workDepartment: 'table_list.columns.workDepartmentId',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedAt: 'table_list.columns.modifiedAt',
  modifiedBy: 'table_list.columns.modifiedBy',
};
